import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["id", "type", "placeholder", "required", "maxlength", "aria-describedby"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "label",
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
        class: _normalizeClass(['input', {'is-danger': _ctx.showError}]),
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        required: _ctx.required,
        maxlength: _ctx.maxLength,
        "aria-describedby": _ctx.ariaDescribedBy,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
      }, null, 42, _hoisted_4), [
        [_vModelDynamic, _ctx.localValue]
      ])
    ]),
    (_ctx.helpText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          id: _ctx.helpId,
          class: "help"
        }, _toDisplayString(_ctx.helpText), 9, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          id: _ctx.errorId,
          class: "help is-danger"
        }, _toDisplayString(_ctx.errorMessage), 9, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}